// extracted by mini-css-extract-plugin
module.exports = {"handle":"illuminated-image_handle__GFrXs"};